import React from 'react'
import { isUndefined } from 'libraries/lodash'
import Icon from 'components/shared/Icon'
import FilterComponent from './FilterComponent'

export default class BooleanFilter extends FilterComponent {
  handleChange = (value) => (e) => {
    this.props.setFilterValue([[[value], '=']])
  }

  render () {
    const [value] = this.value
    const isFalse = !isUndefined(value) && (+value) === 0
    const isTrue = !isUndefined(value) && (+value) !== 0

    return (
      <div className='flex flex-wrap items-start pv6 ph0'>
        <div className='mv0 mh6'>
          <input
            className='dn'
            name={`${this.id}_1`}
            id={`${this.id}_1`}
            type='radio'
            checked={isTrue}
            onChange={this.handleChange('1')}
          />
          <label className='flex' htmlFor={`${this.id}_1`}>
            <Icon
              className='w6 mr2' name={isTrue
                ? 'icon-checkbox-marked-circle-outline'
                : 'icon-checkbox-blank-circle-outline'}
            />
            Yes
          </label>
        </div>
        <div className='mv0 mh6'>
          <input
            className='dn'
            name={`${this.id}_0`}
            id={`${this.id}_0`}
            type='radio'
            checked={isFalse}
            onChange={this.handleChange('0')}
          />
          <label className='flex' htmlFor={`${this.id}_0`}>
            <Icon
              className='w6 mr2' name={isFalse
                ? 'icon-checkbox-marked-circle-outline'
                : 'icon-checkbox-blank-circle-outline'}
            />
            No
          </label>
        </div>
      </div>
    )
  }
}
